import React from 'react'
import HorizontalLine from '@components/HorizontalLine'
import ScrollContainer from '@components/ScrollContainer'
import useQuery from '@hooks/useQuery'
import GET_TASK from '@lib/queries/getTask'
import Card from '@components/Card'
import QueryError from '@components/QueryError'
import Show from '@components/Show'
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native'
import MainLayout from '@layouts/MainLayout'
import { colors } from '@lib/colors'
import { i18n } from '@lib/i18n'

const COPY = i18n.en.WORK_ORDERS.TASK

export default function ({ route }: any) {
  const { workOrderNumber, taskId } = route.params
  const { data, error, loading } = useQuery<TaskData>(GET_TASK, { id: taskId })
  const task = data?.task

  const taskName = task?.name ?? 'N/A'
  const taskStatus = task?.status?.name || ''
  const taskStatusColor = task?.status?.textColor || '#000'
  const taskDetails = task?.details

  return (
    <MainLayout>
      <ScrollContainer>
        <View style={ styles.header }>
          <Text style={ styles.headerTitle }>{ COPY.WORK_ORDER }</Text>
          <Text style={ styles.headerNumber }>#{ workOrderNumber }</Text>
        </View>

        <Show when={loading}>
          <ActivityIndicator />
        </Show>

        <Show when={task}>
          <Card>
            <Text style={ styles.name }>{ taskName }</Text>
            <Text style={ styles.status }>
              Status:{' '}
              <Text style={{ color: taskStatusColor, fontWeight: '600' }}>{ taskStatus }</Text>
            </Text>
            <HorizontalLine color={ colors.gray[400] } />
            <Show
              when={ taskDetails }
              fallback={ <Text style={ styles.noDetails }>{ COPY.NO_DESCRIPTION }</Text> }
            >
              <Text style={ styles.details }>{ taskDetails }</Text>
            </Show>
          </Card>
        </Show>

        <Show when={error}>
          <QueryError text={ COPY.LOAD_FAILED } />
        </Show>
      </ScrollContainer>
    </MainLayout>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingBottom: 50,
  },
  header: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 20,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: '700',
    color: colors.gray[800],
    textAlign: 'left',
  },
  headerNumber: {
    fontSize: 22,
    fontWeight: '400',
    color: colors.gray[500],
    textAlign: 'right',
  },
  name: {
    fontSize: 18,
    fontWeight: '600',
    color: colors.blue[500],
    textAlign: 'left',
    paddingBottom: 10,
  },
  status: {
    fontSize: 16,
    fontWeight: '400',
    paddingBottom: 20,
  },
  details: {
    paddingTop: 20,
  },
  noDetails: {
    paddingTop: 20,
    fontStyle: 'italic',
    color: colors.gray[500],
  },
})
